(function () {
  function initAccordion() {
    const drawer = document.querySelector('header-drawer');
    if (!drawer) return;

    const accordionItems = drawer.querySelectorAll('.menu-drawer__accordion-item');

    accordionItems.forEach(function (details) {
      const summary = details.querySelector(':scope > .menu-drawer__accordion-summary');
      if (!summary) return;

      // 移除原有的 onclick
      details.removeAttribute('onclick');

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        const isOpen = details.hasAttribute('open');
        if (isOpen) {
          details.removeAttribute('open');
        } else {
          details.setAttribute('open', '');
        }
      }, true); // true = capture phase，比 Dawn JS 更早攔截
    });
  }

  // 等 drawer 開啟後再綁定
  document.addEventListener('click', function (e) {
    if (e.target.closest('.header__icon--menu')) {
      setTimeout(initAccordion, 100);
    }
  });

  // 也在頁面載入時執行一次
  document.addEventListener('DOMContentLoaded', initAccordion);
})();
